import OTPInput from "./OTPInput";

function OTPSection({

  otp,

  setOtp,

  verifyOTP,

  timer,

  resendOTP

}) {

  return (

    <>

      <h3 className="otp-title">

        Enter Verification Code

      </h3>

      <p className="otp-text">

        Enter the 6-digit OTP sent to your email.

      </p>

      <OTPInput

        otp={otp}

        setOtp={setOtp}

      />

      <button

        onClick={verifyOTP}

      >

        Verify OTP

      </button>

      <div className="otp-footer">

        {

          timer > 0 ? (

            <p>

              Resend OTP in

              <strong>

                {" "}

                00:{timer.toString().padStart(2,"0")}

              </strong>

            </p>

          ) : (

            <button

              className="resend-btn"

              onClick={resendOTP}

            >

              🔄 Resend OTP

            </button>

          )

        }

      </div>

    </>

  );

}

export default OTPSection;